import React, { useState, useEffect, useCallback } from "react";
import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  Linking,
  Image,
  ScrollView,
} from "react-native";
import { colors } from "src/assets";
import { FormControlLabel, Button } from "src/components";
import { useAccount, useAccountUploadDocumentAction } from "src/hooks";
import LocalText from "src/local";
import alert from "src/components/alert";
import { navigationRef } from "src/hooks/navigation";
import { EventRegister } from "react-native-event-listeners";

export type DocumentsProps = {
  onDone: (documents: Array<string>) => void;
};

export const Documents: React.FC<DocumentsProps> = (props) => {
  const [account] = useAccount();
  const [documents, setDocuments] = useState<Array<string>>([]);
  const [accountUploadDocumentAction] = useAccountUploadDocumentAction();

  useEffect(() => {
    const listener = EventRegister.addEventListener(
      "IdentificationDocumentImage",
      async (e) => {
        const url = await accountUploadDocumentAction(e.dataURL);
        if (url) {
          setDocuments((v) => [...v, url]);
        }
      }
    );
    return () => {
      EventRegister.removeEventListener(listener as string);
    };
  }, [accountUploadDocumentAction]);

  const onImageUpload = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target?.files?.[0]) {
        navigationRef.current?.navigate("CustomImageCrop", {
          eventName: "IdentificationDocumentImage",
          file: event.target?.files?.[0],
          // maxSize: {
          //   width: 3000,
          //   height: 3000,
          // },
        });
      }
      event.target.value = "";
    },
    []
  );

  const imageRemoveHandler = (index: number) => {
    alert(
      LocalText.screens.identification.removeImageAlertTitle,
      undefined,
      [
        {
          text: LocalText.common.cancel,
          style: "cancel",
        },
        {
          text: LocalText.common.delete,
          style: "destructive",
          onPress: () => {
            const array = [...documents];
            array.splice(index, 1);
            setDocuments(array);
          },
        },
      ],
      { cancelable: false }
    );
  };
  const doneHandler = useCallback(async () => {
    if (documents.length === 0) {
      alert(LocalText.screens.identification.emptyImagesAlertTitle, undefined, [
        {
          text: LocalText.common.ok,
          style: "cancel",
        },
      ]);
      return;
    }

    props.onDone(documents);
  }, [documents]);

  return (
    <View style={styles.container}>
      <input
        id="document-image-upload"
        type="file"
        onChange={onImageUpload}
        accept="image/*"
        style={{ display: "none" }}
      />
      <ScrollView style={{ backgroundColor: "white" }}>
        <View style={{ paddingHorizontal: 16, paddingBottom: 16 }}>
          <Text style={{ fontSize: 14, marginTop: 4 }}>
            チョク！では健全な運営を目的とした、ユーザーの本人確認手続きを実施しております。
          </Text>
          <Text style={{ fontSize: 14, marginTop: 4 }}>
            以下の本人確認資料のうち一つをデータ化し、ご提出いただきますようお願いいたします。
          </Text>
          <Text style={{ fontSize: 14, marginTop: 4 }}>
            入力いただいたプロフィール内容と本人確認資料が異なる場合、アカウントが有効化されません。
          </Text>
          <Text style={{ fontSize: 14, marginTop: 4 }} />
          <Text style={{ fontSize: 14, marginTop: 4 }}>
            【日本在住のお客様（日本国籍・外国籍）】
          </Text>
          <TouchableOpacity
            onPress={() =>
              Linking.openURL("https://bitflyer.com/ja-jp/identification")
            }
          >
            <Text style={{ fontSize: 14, marginTop: 4 }}>・運転免許証</Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              Linking.openURL("https://bitflyer.com/ja-jp/identification")
            }
          >
            <Text style={{ fontSize: 14, marginTop: 4 }}>・個人番号カード</Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              Linking.openURL("https://bitflyer.com/ja-jp/identification")
            }
          >
            <Text style={{ fontSize: 14, marginTop: 4 }}>
              ・各種健康保険証（紙型健康保険証）
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              Linking.openURL("https://bitflyer.com/ja-jp/identification")
            }
          >
            <Text style={{ fontSize: 14, marginTop: 4 }}>・各種福祉手帳</Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              Linking.openURL("https://bitflyer.com/ja-jp/identification")
            }
          >
            <Text style={{ fontSize: 14, marginTop: 4 }}>・住民票の写し</Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              Linking.openURL("https://bitflyer.com/ja-jp/identification")
            }
          >
            <Text style={{ fontSize: 14, marginTop: 4 }}>
              ・特別永住者証明書
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              Linking.openURL("https://bitflyer.com/ja-jp/identification")
            }
          >
            <Text style={{ fontSize: 14, marginTop: 4 }}>
              ・パスポート（日本国が発行する旅券）
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              Linking.openURL("https://bitflyer.com/ja-jp/identification")
            }
          >
            <Text style={{ fontSize: 14, marginTop: 4 }}>
              ・各種健康保険証・共済組合会員証（カード型健康保険証）
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              Linking.openURL("https://bitflyer.com/ja-jp/identification")
            }
          >
            <Text style={{ fontSize: 14, marginTop: 4 }}>
              ・各種年金手帳（厚生年金、国民年金、共済年金等）
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              Linking.openURL("https://bitflyer.com/ja-jp/identification")
            }
          >
            <Text style={{ fontSize: 14, marginTop: 4 }}>・印鑑登録証明書</Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              Linking.openURL("https://bitflyer.com/ja-jp/identification")
            }
          >
            <Text style={{ fontSize: 14, marginTop: 4 }}>・在留カード</Text>
          </TouchableOpacity>
          <Text style={{ fontSize: 14, marginTop: 4 }}>【法人のお客様】</Text>
          <TouchableOpacity
            onPress={() =>
              Linking.openURL("https://bitflyer.com/ja-jp/identification")
            }
          >
            <Text style={{ fontSize: 14, marginTop: 4 }}>・登記事項証明書</Text>
          </TouchableOpacity>
        </View>
        {account?.identificationMessage && (
          <FormControlLabel text={account.identificationMessage} />
        )}
        {documents.map((document, index) => (
          <TouchableOpacity
            key={document}
            onPress={() => imageRemoveHandler(index)}
          >
            <Image
              style={{
                height: 150,
                marginBottom: 16,
              }}
              resizeMode="contain"
              source={{ uri: document }}
            />
          </TouchableOpacity>
        ))}
      </ScrollView>
      <View style={styles.actionContainer}>
        <label htmlFor="document-image-upload">
          <Button
            containerStyle={styles.chatActionContainer}
            variant={"secondary"}
            title={LocalText.screens.identification.imageUpload}
          />
        </label>
        <Button
          containerStyle={styles.offerActionContainer}
          //   loading={accountUpdateLoading}
          variant={"primary"}
          title={LocalText.common.next}
          onPress={() => doneHandler()}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  actionContainer: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    padding: 16,
    shadowColor: colors.black,
    shadowOffset: { width: 0, height: -2 },
    shadowOpacity: 0.1,
    backgroundColor: colors.white,
  },
  chatActionContainer: {
    flex: 1,
    marginRight: 8,
  },
  offerActionContainer: {
    flex: 1,
    marginLeft: 8,
  },
  container: {
    flex: 1,
  },
});
